module.exports = " <div class=card _v-7021c5b7=\"\"> <header _v-7021c5b7=\"\"> <img class=avatar width=40 height=40 :alt=user.name :src=user.img _v-7021c5b7=\"\"> <p class=name _v-7021c5b7=\"\">{{user.name}}</p> </header> <footer _v-7021c5b7=\"\"> <input class=search type=text placeholder=\"search user...\" @keyup=\"onKeyup | debounce 150\" _v-7021c5b7=\"\"> </footer> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-7021c5b7!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/card.vue
 ** module id = 311
 ** module chunks = 0
 **/